import { UpdateCostCenterPriceStateEnums } from "src/app/enum/update-cost-center-price-enums";

export class UpdateCostCenterPriceModel {
    updateCostCenterPriceId: number = 0;
    branchId: number = 0;
    consecutive: number = 0;
    updateCostCenterPriceState: number = UpdateCostCenterPriceStateEnums.open;
    observation: string | null = null;
    createDate: string | null = null;
    userNameCreate: string | null = null;
    updateDate: string | null = null;
    userNameUpdate: string | null = null;
}